import { Toolbar, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { ListProps, useDataProvider, CreateButton, useNotify, usePermissions } from 'react-admin';
import { Raffle } from '../../types/raffle';
import "./index.css";
import ActiveDreamHome from './ActiveDreamHomeList';
import NewDreamHomeList from './NewDreamHomeList'
import OldDreamHomeList from './OldDreamHomeList';
import { useDispatch } from "react-redux";
import { removeMark } from '../../redux/actions/propertyActions';
import { checkPermission } from '../../helpers/checkPermissions';

const Title: FC = () => {
    let { permissions } = usePermissions();
    return (
        <>
            <div className="dreamhome-main-title">
                Prize Management
        </div>
            <div>

            </div>
            <div className="active-create-container">
                <div>
                    Dream Home Management
            </div>
                <div>
                    {
                        checkPermission(permissions,"Dream home","Update") &&
                        <CreateButton className="add-button" label="Add new dream home" to='dreamHome/create' />
                    }
                </div>
            </div>
        </>
    )
}

const DreamHome: FC<ListProps> = () => {
    const dispatch = useDispatch()
    const dataProvider = useDataProvider()
    const notify = useNotify()
    const [state, setState] = useState({
        raffles: Array<Raffle>(),
        rafflesCount: 0,
        rafflesPage: 1,
        rafflesPerPage: 10,
        oldRaffles: Array<Raffle>(),
        oldRafflesCount: 0,
        oldRafflesPage: 1,
        oldRafflesPerPage: 10,
        active: Array<Raffle>(),
        isNewActive: true,
        changeActive: false,
    })

    const toggleDreamHome = (e: any) => {
        const isActive = e.target.checked
        setState({ ...state, isNewActive: isActive })
    }

    useEffect(() => {
        dispatch(removeMark())
        getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        const raffles = await getRaffle(false, 1, 10);
        const oldRaffles = await getRaffle(true, 1, 10);
        const result = await dataProvider.getDreamhomeList("raffles/active/cms",{
            filter: { },
            pagination: { page: 1, perPage: 10 },
            sort: { field: "id", order: "ASC" },
        }) as any;
        setState({
            ...state,
            raffles: raffles.data,
            oldRaffles: oldRaffles.data,
            active: result.data,
            rafflesCount: raffles.total,
            oldRafflesCount: oldRaffles.total
        });
    }

    const getRaffle = async (isClosed, page, perPage) => {
        return await dataProvider.getDreamhomeList("raffles", {
            filter: { isClosed: isClosed },
            pagination: { page: page, perPage: perPage },
            sort: { field: "id", order: "ASC" },
        }) as any;
    }


    const handleChangePage = async (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        const raffles = await getRaffle(false, newPage + 1, state.rafflesPerPage)
        setState({ ...state, rafflesPage: newPage + 1, raffles: raffles.data, rafflesCount: raffles.total })
    };

    const handleLastRafflePage = async () => {
        const page = Math.ceil(state.rafflesCount/state.rafflesPerPage)
        const raffles = await getRaffle(false, page, state.rafflesPerPage)
        setState({ ...state, rafflesPage: page, raffles: raffles.data, rafflesCount: raffles.total })
    }

    const handleLastOldRafflePage = async () => {
        const page = Math.ceil(state.oldRafflesCount/state.oldRafflesPerPage)
        const raffles = await getRaffle(true,page,state.oldRafflesPerPage)
        setState({...state, oldRafflesPage: page, oldRaffles: raffles.data, oldRafflesCount: raffles.total})
    }

    const handleChangeRowsPerPage = async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const perPage = parseInt(event.target.value, 10)
        const raffles = await getRaffle(false, state.rafflesPage, perPage)
        setState({ ...state, raffles: raffles.data, rafflesCount: raffles.total, rafflesPerPage: perPage })
    };

    const handleOldChangePage = async (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        const raffles = await getRaffle(true, newPage + 1, state.oldRafflesPerPage)
        setState({ ...state, oldRafflesPage: newPage + 1, oldRaffles: raffles.data, oldRafflesCount: raffles.total })
    };

    const handleOldChangeRowsPerPage = async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const perPage = parseInt(event.target.value, 10)
        const raffles = await getRaffle(true, state.oldRafflesPage, perPage)
        setState({ ...state, oldRaffles: raffles.data, oldRafflesCount: raffles.total, oldRafflesPerPage: perPage })
    };

    const changeStatus = async (raffle: Raffle) => {
        const result = await dataProvider.update("raffles", {
            data: raffle,
            id: raffle._id,
            previousData: {} as any
          });
        if (result.data.message) {
            notify(result.data.message, "error")
            return
        }
        if (result.data.active && result.data.isTrending) {
            await dataProvider.addFeatured("DREAMHOME",result.data._id)
        } else {
            await dataProvider.removeFeatured("DREAMHOME",result.data._id)
        }
        setState({ ...state, changeActive: !state.changeActive })
        getData()
    }
    return (
        <>
            <Title />
            <ActiveDreamHome
                toggleDreamHome={toggleDreamHome}
                isActive={state.isNewActive}
                changeStatus={changeStatus}
                raffle={state.active}
            />
            <Toolbar id="active-toggle">
                <div className="active-table-title">
                <Typography variant="h6" gutterBottom >
                    {state.isNewActive ? <> New Dream Home </> : <>Close competition</>}
                </Typography>
                </div>
            </Toolbar>
            {
                state.isNewActive ?
                    <NewDreamHomeList
                        raffles={state.raffles}
                        changeStatus={changeStatus}
                        handleChangePage={handleChangePage}
                        rowsPerPage={state.rafflesPerPage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        total={state.rafflesCount}
                        page={state.rafflesPage - 1}
                        handleLastPage={handleLastRafflePage}
                    />
                    :
                    <OldDreamHomeList
                        raffles={state.oldRaffles}
                        handleChangePage={handleOldChangePage}
                        rowsPerPage={state.oldRafflesPerPage}
                        handleChangeRowsPerPage={handleOldChangeRowsPerPage}
                        total={state.oldRafflesCount}
                        page={state.oldRafflesPage - 1}
                        handleLastPage={handleLastOldRafflePage}
                    />
            }
        </>
    )
}

export default DreamHome